<div>
    <mat-form-field>
      <div>
        <mat-toolbar class="custom-toolbar">
          <input matInput class="input-upload" [value]="fileName"/>
          <mat-icon>file_upload</mat-icon>
        </mat-toolbar>
        <input
          #fileInput
          type="file"
          id="fileInput"
          (click)="beforeFileSelect($event)"
          (change)="selectFile($event)"
          name="fileInput"
          style="width: 100%;"
          [attr.multiple]="permiteMultiples ? '' : null"
        />
      </div>
    </mat-form-field>
  </div>
  <div *ngIf="message" class="message">
    {{ message }}
  </div>